<div class="wallet_s_single_wrapper synergy-single post-single row">
  <div class="s_single col-md-12">
    <div appSticky position="top" class="row s_single-title-container">
      <div class="col-md-12">
        <h1 class="s_single-title">{{post_event.title}}</h1>
      </div>
    </div>
    <div class="row s_single-img-area">
      <div class="col-md-12 s_single-img-container">
        <div class="s_single-img">
          <img src={{post_event.imageURL}} alt={{post_event.title}} />
        </div>
        <div *ngIf="post_event.dateTime" class="s_single-date">
          <span class="white mdi mdi-calendar"></span> {{ post_event.dateTime | date: 'd.M.y'}}
        </div>
      </div>
    </div>
    <div class="row s_single-details">
      <div class="col-md-12">
        <div class="row s_single-info-container">
          <div class="col-md-6 s_single-info">
            <div *ngIf="!post_event.dateTime" class="info-row"><span class="mdi mdi-clock"></span>{{ post_event.createdAt | date: 'd.M.y' }}
            </div>
            <div *ngIf="post_event.location" class="info-row"><span class="mdi mdi-map"></span>{{post_event.location}}
            </div>
            <div class="info-row"><span class="mdi mdi-shopping"></span>{{post_event.partner.name}}
            </div>
          </div>
          <div class="col-md-6 s_single-share">
            <sng-share-icon [item]="post_event"></sng-share-icon>
          </div>
        </div>
        <div class="row s_single-description">
          <div class="col-md-12">
            <sng-rich-editor-view [description]="post_event.description"></sng-rich-editor-view>
            <!-- <div class="editor-content" [innerHTML]="post_event.description"></div> -->
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
